import { defineComponent as o, createBlock as t, openBlock as r, unref as p, mergeProps as d, withCtx as u, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconSwap",
  __name: "IconSwap",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (m, a) => (r(), t(p(i), d(n, { "view-box": "0 0 24 24" }), {
      default: u(() => [...a[0] || (a[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M7 3.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5M4.75 7a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M13 6.25a.75.75 0 0 0 0 1.5h5.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l2.647-2.646a1.25 1.25 0 0 0 0-1.768L17.53 3.47a.75.75 0 1 0-1.06 1.06l1.72 1.72H13m-7.19 10H11a.75.75 0 0 1 0 1.5H5.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-2.647-2.646a1.25 1.25 0 0 1 0-1.768L6.47 13.47a.75.75 0 1 1 1.06 1.06l-1.72 1.72" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M14.5 13.25a1.25 1.25 0 0 0-1.25 1.25v5a1.25 1.25 0 0 0 1.25 1.25h5a1.25 1.25 0 0 0 1.25-1.25v-5a1.25 1.25 0 0 0-1.25-1.25h-5m.25 6v-4.5h4.5v4.5h-4.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
